// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"a4585188","47":"a56beb4c","69":"16f05528","679":"a4585188"}[chunkId] + ".chunk.css";
};